import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

export class CustomValidators {
  static mobileNumber(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value || !value.number) {
        return { required: true };
      }
      // if (!/^[0-9]{7,10}$/.test(value.number)) {
      //   return { invalidMobile: true };
      // }

      const number = String(value.number);
      if (!/^\d+$/.test(number)) {
        return { invalidCharacters: true };
      }

      if (number.length !== 10 && number.length !== 11) {
        return {
          invalidLength: true,
        };
      }

      if ((number.length === 11 && !number.startsWith('0')) || (number.length === 10 && !number.startsWith('1'))) {
        return { mobileNumber: true };
      }

      return null;
    };
  }

  static adminUserMobileNumber(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) {
        return { required: true };
      }
      // if (!/^[0-9]{7,10}$/.test(value.number)) {
      //   return { invalidMobile: true };
      // }

      const number = String(value);
      if (!/^\d+$/.test(number)) {
        return { invalidCharacters: true };
      }

      if (number.length !== 10 && number.length !== 11) {
        return {
          invalidLength: true,
        };
      }

      if ((number.length === 11 && !number.startsWith('0')) || (number.length === 10 && !number.startsWith('1'))) {
        return { mobileNumber: true };
      }

      return null;
    };
  }

  static ssn(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      if (!/^[0-9]{14}$/.test(value)) {
        return { invalidSSN: true };
      }
      return null;
    };
  }

  static strongPassword(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      if (/\s/.test(value)) {
        return { passwordContainsSpaces: true };
      }

      if (!/[a-z]/.test(value)) {
        return { passwordMissingLowercase: true };
      }

      if (!/[A-Z]/.test(value)) {
        return { passwordMissingUppercase: true };
      }

      if (!/\d/.test(value)) {
        return { passwordMissingNumber: true };
      }

      if (!/[!@#$%^&*()\{\}\[\]\-_=+/\\~.<>:;"']/.test(value)) {
        return { passwordMissingSpecial: true };
      }

      return null;
    };
  }

  // static strongPassword(): ValidatorFn {
  //   return (control: AbstractControl): ValidationErrors | null => {
  //     const value = control.value;
  //     if (!value) return null;
  //     const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\{\}\[\]\-_=+/\\~.<>:;"'])[^\s]{8,50}$/;
  //     if (!pattern.test(value)) {
  //       return { weakPassword: true };
  //     }
  //     return null;
  //   };
  // }

  static passwordMatch(passwordField: string, confirmField: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormGroup)) {
        return null;
      }
      const password = control.get(passwordField)?.value;
      const confirm = control.get(confirmField)?.value;
      if (!password || !confirm) return null;
      return password === confirm ? null : { passwordMismatch: true };
    };
  }

  static email(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!pattern.test(value)) {
        return { invalidEmail: true };
      }
      return null;
    };
  }

  static barcode(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      if (!/^\d{13}$/.test(value)) {
        return { invalidBarcode: true };
      }
      return null;
    };
  }

  static digitsOnly(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      if (!/^[0-9]+$/.test(value)) {
        return { digitsOnly: true };
      }
      return null;
    };
  }
}
